import React, { useEffect } from 'react';
import { Message, Header, Label, SegmentGroup, Segment, Image, Button, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import '@styles/PostHeader.css'; // Ensure you have a CSS file for custom styles

const PostHeader = ({ post, config = {} }) => {
    const { image, title, date, summary, path } = post;

    // Split the summary into sentences
    const summaryItems = summary.split('.').filter(sentence => sentence.trim() !== '');

    // Function to update Open Graph meta tags for better LinkedIn sharing
    useEffect(() => {
        // Update page title
        document.title = `${title} - Cloud CZR`;

        // Function to update or create meta tag
        const updateMetaTag = (property, content, isProperty = true) => {
            const attribute = isProperty ? 'property' : 'name';
            let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
            
            if (!metaTag) {
                metaTag = document.createElement('meta');
                metaTag.setAttribute(attribute, property);
                document.head.appendChild(metaTag);
            }
            metaTag.setAttribute('content', content);
        };

        // Update Open Graph tags
        updateMetaTag('og:title', `${title} - Cloud CZR`);
        updateMetaTag('og:description', summary);
        updateMetaTag('og:url', window.location.href);
        updateMetaTag('og:type', 'article');
        
        // Try to use PNG version if available, otherwise fallback to SVG
        let imageUrl = `${window.location.origin}${process.env.PUBLIC_URL}${image}`;
        
        // Check if there's a PNG version and use it for better LinkedIn compatibility
        if (image.includes('.svg')) {
            const pngVersion = image.replace('.svg', '.png');
            // For LinkedIn sharing, prefer PNG images
            imageUrl = `${window.location.origin}${process.env.PUBLIC_URL}${pngVersion}`;
        }
        
        updateMetaTag('og:image', imageUrl);
        updateMetaTag('og:image:width', '1200');
        updateMetaTag('og:image:height', '630');
        updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');

        // Update Twitter Card tags
        updateMetaTag('twitter:card', 'summary_large_image', false);
        updateMetaTag('twitter:title', `${title} - Cloud CZR`, false);
        updateMetaTag('twitter:description', summary, false);
        updateMetaTag('twitter:image', imageUrl, false);
        updateMetaTag('twitter:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com', false);

        // Update description meta tag
        updateMetaTag('description', summary, false);

        // Cleanup function
        return () => {
            document.title = 'CloudCaesar';
        };
    }, [title, summary, image]);

    // Function to share on LinkedIn with pre-populated content
    const handleLinkedInShare = () => {
        const url = encodeURIComponent(window.location.href);
        
        // LinkedIn sharing URL - using the most compatible format
        // This format relies on Open Graph tags for content population
        const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
        
        // Open in a new window with appropriate size
        const popup = window.open(linkedInUrl, '_blank', 'width=600,height=600,scrollbars=yes,resizable=yes,toolbar=no,location=no,status=no,menubar=no');
        
        // If the popup was blocked, provide fallback
        if (!popup) {
            alert('Please allow popups to share on LinkedIn, or copy this URL to share manually: ' + window.location.href);
        }
    };

    return (
        <SegmentGroup horizontal style={{ backgroundColor: '#702963' }}>
            <Segment floated="right" className="post-item" style={{ position: 'relative' }}>
                <Image src={`${process.env.PUBLIC_URL}${image}`} alt="Cloud CZR, Cloudczr, cloudczr.com" className="post-item-image" />
                <Button
                    icon
                    size="small"
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        backgroundColor: '#0077B5',
                        color: 'white',
                        zIndex: 10,
                        borderRadius: '50%',
                        padding: '8px'
                    }}
                    onClick={handleLinkedInShare}
                    title="Share on LinkedIn"
                >
                    <Icon name="linkedin" />
                </Button>
            </Segment>
            <Segment>
            <Header as="h3" textAlign="center" style={{ backgroundColor: '#702963' }}>
                <Link to={`/${path}`} style={{ color: '#a9885c' }}>{title}</Link>
                <Header.Subheader>
                    <Label style={{ color: '#702963', backgroundColor: '#a9885c' }} basic>{date}</Label>
                </Header.Subheader>
            </Header>
                <div className="feed-item-background-container">
                    <div className="message-overlay">
                        <Message className="message-custom">
                            <Message.Header>Summary</Message.Header>
                            <Message.List items={summaryItems} />
                        </Message>
                    </div>
                </div>
            </Segment>
        </SegmentGroup>
    );
};

export default PostHeader;